import { render, staticRenderFns } from "./AppSidebarLink.vue?vue&type=template&id=10ff9e4e&"
import script from "./AppSidebarLink.vue?vue&type=script&lang=js&"
export * from "./AppSidebarLink.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports